<template>
  <div class="w-1/4" data-aos="fade-up">
    <div class="about-card h-full bg-white rounded-45p border border-gray-200 shadow-xl dark:bg-gray-800 dark:border-gray-700 px-6 py-10">
      <div class="flex flex-col items-center gap-3">
        <gradient-line class="mb-4"/>
        <div class=" w-full text-center text-20 text-black font-bold">
          <slot name="title"/>
        </div>
        <div class="text-16 text-gray-500 font-normal text-left">
          <slot name="description"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GradientLine from '@/components/UI_components/GradientLine'

export default {
  name: 'AboutHelpYourBusinessCard',
  components: { GradientLine }
}
</script>

<style scoped>
.about-card {
  transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
}

.about-card:hover {
  border-color: #FFCE1F;
  transform: translateY(-6px);
  box-shadow: 0 22px 40px rgba(4, 23, 41, .16);
}

@media (prefers-reduced-motion: reduce) {
  .about-card {
    transition: none;
  }

  .about-card:hover {
    transform: none;
  }
}
</style>
